export enum MachineCounterTrigger {
    START = "START",
    STOP = "STOP",
}